export default "__VITE_ASSET__BZTGwyfa__"